import { z } from "zod";
import { FACTION_IDS } from "@frontier/content/factions";

export const factionIdSchema = z.enum(FACTION_IDS);
const loginNameSchema = z.string().min(3).max(24).regex(/^[A-Za-z0-9_]+$/).toLowerCase();
const passwordSchema = z.string().min(10).max(128);

export const pilotNameSchema = z.string()
  .regex(/^[^\p{Cc}\p{Cf}\p{Zl}\p{Zp}\p{Default_Ignorable_Code_Point}]*$/u, "Nickname cannot contain control characters")
  .trim().min(1).max(24);
export const profileNameRequestSchema = z.object({ name: pilotNameSchema }).strict();
export type ProfileNameRequest = z.infer<typeof profileNameRequestSchema>;

export const accountSummarySchema = z.union([
  z.object({ login: z.string().min(3).max(24).regex(/^[a-z0-9_]+$/) }).strict(),
  z.object({ provider: z.enum(["vkplay", "vkgames"]) }).strict(),
]);
export type AccountSummary = z.infer<typeof accountSummarySchema>;

export const vkPlayLaunchRequestSchema = z.object({
  launchParams: z.string().min(1).max(8192),
}).strict();
export type VkPlayLaunchRequest = z.infer<typeof vkPlayLaunchRequestSchema>;

const platformAppIdSchema = z.string().max(16).regex(/^[1-9][0-9]*$/)
  .refine((value) => Number.isSafeInteger(Number(value)), "App ID must be a positive safe integer");
export const vkPlayConfigSchema = z.discriminatedUnion("enabled", [
  z.object({ enabled: z.literal(false) }).strict(),
  z.object({ enabled: z.literal(true), appId: platformAppIdSchema }).strict(),
]);
export type VkPlayConfig = z.infer<typeof vkPlayConfigSchema>;

export const vkGamesLaunchRequestSchema = z.object({
  launchParams: z.string().min(1).max(8192),
  displayName: pilotNameSchema.optional(),
}).strict();
export type VkGamesLaunchRequest = z.infer<typeof vkGamesLaunchRequestSchema>;

export const vkGamesConfigSchema = z.discriminatedUnion("enabled", [
  z.object({ enabled: z.literal(false) }).strict(),
  z.object({ enabled: z.literal(true), appId: platformAppIdSchema }).strict(),
]);
export type VkGamesConfig = z.infer<typeof vkGamesConfigSchema>;

export const factionRequestSchema = z.object({
  factionId: factionIdSchema,
}).strict();
export type FactionRequest = z.infer<typeof factionRequestSchema>;

export const registerRequestSchema = z.object({
  login: loginNameSchema,
  password: passwordSchema,
  factionId: factionIdSchema,
}).strict();
export type RegisterRequest = z.infer<typeof registerRequestSchema>;

export const loginRequestSchema = z.object({
  login: loginNameSchema,
  password: passwordSchema,
}).strict();
export type LoginRequest = z.infer<typeof loginRequestSchema>;

export const logoutResponseSchema = z.object({ ok: z.literal(true) }).strict();
export type LogoutResponse = z.infer<typeof logoutResponseSchema>;
